<template>
    <div class="baner-vertical-long baner-bottom-vertical" v-if="banerArr != null">
        <!-- 1200x100 -->
        <div class="banner-full-size desctop-baner" v-if="!iSmobile">
            <a :href="banerArr[0].link">
                <img :src="banerArr[0].baners_gif.baner_desctop" alt="">
            </a>
        </div>
        <div class="banner-full-size mobile-baner" v-if="iSmobile">
            <a :href="banerArr[0].link">
                <img :src="banerArr[0].baners_gif.baner_mobile" alt="">
            </a>
        </div>
        <!-- Нижний банер
        {{options[0].page}} -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'baner-bottom-vaertical',
        props: ['options'],
        components: {
        },
        data () {
            return {
                banerArr: null,
                iSmobile: false,
            }
        },
        computed: mapGetters({
            banerSystem: 'loadBanerSystem',
            currentCity: 'loadCurrentCity',
        }),
        methods: {
            suffleArr() {
                var data = this.banerSystem.bottom_vertical_baners,
                    city = this.currentCity;
                var filteredItems = data.filter(item => {
                    return (
                        item.gorod.slug == city && 
                        item.view_on_page.find(x => x == this.options[0].page) &&
                        item.baner_init == 'true'
                    );
                });
                if (filteredItems.length > 0) {
                    this.banerArr = _.shuffle(filteredItems);
                } else {
                    this.banerArr = null;
                }
                // console.log(filteredItems)
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.suffleArr();
            this.isMobileCheck();
            this.checkResize();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/baner-system/baner-bottom-vertical.scss';
    // @import '@/styles/respond/404/404-page-respond.scss';
</style>